<script>
import Layout from "../../../layouts/main";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Switches from "vue-switches";

Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
/**
 * new orden component
 */
export default {
  page: {
    title: "Registros de caja",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    // PageHeader,
    // DatePicker,
    Switches,
    // Vuetable,
    // VuetablePagination,
    // Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      estado_caja: false,
      validarEdit: true,
      temp_inicio: "",
      tempObservacion_inicio: "",
      showModalN: false,
      formEgreso : {},
      cajaActual: null,
      arrayCajas: [],
      arrayUsuarios: [],
      validateCaja: false,
      disabledInicio: false,
      swCierre: false,
      swInicio: false,
      disabledCierre: true,
      idCaja: "",
      formInicio: {
        inicio: "",
        observacion_inicio: "",
      },
      formCierre: {
        usuario_recibe: null,
        cierre_efectivo: "",
        cierre_transferencia: "",
        cierre_tarjeta: "",
        cierre_deposito: "",
        total_cierre: "",
      },
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
        process.env.VUE_APP_URL +
        "productos/stock/busqueda?departamento=" +
        0 +
        "&estante=" +
        0,
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      submitted: false,
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      title: "REGISTROS DE CAJA",
      items: [
        {
          text: "Cotizaciones",
          href: "/",
        },
        {
          text: "Editar cotización",
          active: true,
        },
      ],
      showModalL: false, //Loading
      showModalV: false, // Validar
    };
  },
  validations: {
    temp_inicio: { required },
    formInicio: {
      inicio: { required },
      observacion_inicio: { required },
    },
    formCierre: {
      usuario_recibe: { required },
      cierre_efectivo: { required },
      cierre_transferencia: { required },
      cierre_tarjeta: { required },
      cierre_deposito: { required },
      total_cierre: { required },
    },
    formEgreso:{
      cantidad : {required},
      descripcion : {required}
    }
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    let me = this;
    me.selectUser();
    me.validarCaja();
    me.getCajas();
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    infoCaja(idx) {
      this.cajaActual = this.arrayCajas[idx];
      this.$bvModal.show("modalInfo");
    },
    toEditInicio() {
      if (this.validateCaja) {
        if (!this.swInicio) {
          this.disabledInicio = true;
          this.disabledCierre = false;
        } else {
          this.tempObservacion_inicio =
            "Inicio de caja editado el " + this.showHour(new Date());
          this.disabledCierre = true;
          this.disabledInicio = false;
        }
      }
    },
    async getCajas() {
      // let me = this;
      // console.log(this.userT.tienda,this.userT);
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL +
            "caja/get_cierres?" +
            "&usuario=" +
            this.userT.id+
            '&tienda='+this.userT.tienda,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayCajas = response.data.data;
        // console.log("cajas", response);
      } catch (error) {
        console.log(error);
      }
    },
    validarCaja() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "caja/get_validate?" +
            "&usuario=" +
            this.userT.id+
            '&tienda='+this.userT.tienda,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          if (response.data.validate) {
            // console.log("validate", response);
            me.idCaja = response.data.validate.id;
            me.estado_caja = response.data.validate.estado_cierre;
            // console.log( me.estado_caja);
            me.validateCaja = true;
            me.formInicio.inicio = "Q " + response.data.validate.inicio_caja;
            me.formInicio.observacion_inicio =
              response.data.validate.observacion;
            me.disabledCierre = false;
            me.disabledInicio = true;
            me.validarEdit = response.data.validate.estado_edit;
            me.swInicio = false;
            me.$bvModal.hide("modalValidacion");
            return;
          }
          me.$bvModal.show("modalValidacion");
          me.clean();
        });
    },
    inicioRapido() {
      let me = this;
      // console.log(this.userT.tienda);
      axios
        .post(
          process.env.VUE_APP_URL + "caja/store",
          {
            inicio_caja: 0,
            observacion: "Inicio de caja rápido " + this.showHour(new Date()),
            usuario: me.userT.id,
            tienda: this.userT.tienda,
          },
          {
            headers: { "x-token": me.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Inicio de caja rápido realizado", me.options);
          me.validarCaja();
          me.disabledInicio = true;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        });
    },
    async selectUser() {
      let me = this;
      this.arrayUsuarios = [];
      const response = await axios.get(this.apiUrl + "users/get_usuarios", {
        headers: { "x-token": this.userT.token },
      });
      me.arrayUsuarios = response.data.data;
    },
    validaciones(opc) {
      this.submitted = true;
      // console.log(this.repit)
      // stop here if form is invalid
      const { cantidad, descripcion } = this.formEgreso;
      // console.log(this.$v.$invalid, this.repit);
      if (cantidad == '' || descripcion == '') {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.saveEgreso();
        }
      }
    },
    saveEgreso(){
      const { cantidad, descripcion } = this.formEgreso;
      const me = this;
      
      axios
        .post(process.env.VUE_APP_URL + "caja/egreso", {
            'id':me.idCaja,
            'monto'    : cantidad,
            'razon' : descripcion,
            'usuario' :   this.userT.id ,
            'tienda' :   this.userT.tienda ,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(" Egreso Guardado", this.options);
          this.showModalN = false;
          this.showModalL = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.showModalL = false;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        });
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.formCliente.$reset();
          this.limpiarVariables();
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
        case "productos": {
          this.arrayProductos = [];
          this.producto = "";
          break;
        }
        case "servicios": {
          this.arrayServicios = [];
          this.servicio = "";
          break;
        }
      }
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalNP = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    validateInicio() {
      this.$v.formInicio.$touch();
      const { inicio, observacion_inicio } = this.formInicio;
      if (inicio == "" || observacion_inicio == "") {
        Vue.toasted.error("Complete los campos de inicio", this.options);
      } else {
        this.saveInicio();
      }
    },
    //Guardar registro
    saveInicio() {
      axios
        .post(
          process.env.VUE_APP_URL + "caja/store?tienda="+this.userT.tienda,
          {
            inicio_caja: parseFloat(
              this.converMaskToNumberxd(this.formInicio.inicio)
            ),
            observacion: this.formInicio.observacion_inicio,
            usuario: this.userT.id,
            tienda: this.userT.tienda,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.validarCaja();
          Vue.toasted.success("Inicio de caja hecho", this.options);
          this.disabledInicio = true;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        });
    },
    editInicio() {
      this.$v.temp_inicio.$touch();
      if (this.temp_inicio == "") {
        Vue.toasted.error("Complete los campos de inicio", this.options);
      } else {
        axios
          .put(
            process.env.VUE_APP_URL + "caja/update",
            {
              id: this.idCaja,
              inicio_caja: parseFloat(
                this.converMaskToNumberxd(this.temp_inicio)
              ),
              observacion: this.tempObservacion_inicio,
              usuario: this.userT.id,
            },
            {
              headers: { "x-token": this.userT.token },
            }
          )
          .then(() => {
            this.validarCaja();
            Vue.toasted.success("Inicio de caja editado", this.options);
            this.disabledInicio = true;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
      }
    },
    validateCierre() {
      this.$v.formCierre.$touch();
      const {
        cierre_efectivo,
        cierre_deposito,
      } = this.formCierre;
      if (
        cierre_efectivo == "" ||
        cierre_deposito == "" 
      ) {
        Vue.toasted.error("Complete los campos de cierre", this.options);
      } else {
        this.saveCierre();
      }
    },
    saveCierre() {
  
       axios
          .put(
            process.env.VUE_APP_URL + "caja/fin_caja",
            {
              fin_caja: parseFloat(
                this.converMaskToNumberxd(this.formCierre.cierre_efectivo)
              ),
              monto_deposito: parseFloat(
                this.converMaskToNumberxd(this.formCierre.cierre_deposito)
              ),
              usuario: this.userT.id,
              id: this.idCaja,
            },
            {
              headers: { "x-token": this.userT.token },
            }
          )
          .then(async () => {
            await this.validarCaja();
            await this.getCajas();
            this.$bvModal.hide("modalValidacion");
            Vue.toasted.success("Cierre de caja procesado", this.options);
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
    },
    clean() {
      this.$v.$reset();
      this.validateCaja = false;
      this.disabledInicio = false;
      this.disabledCierre = true;
      this.swCierre = false;
      this.swInicio = false;
      this.formInicio = {
        inicio: "",
        observacion_inicio: "",
      };
      this.formCierre = {
        usuario_recibe: null,
        cierre_efectivo: "",
        cierre_transferencia: "",
        cierre_tarjeta: "",
        cierre_deposito: "",
        total_cierre: "",
      };
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    onActionClicked(action) {

      if (action == "new-item") {
        this.formEgreso.cantidad = "";
        this.formEgreso.descripcion = "";
        this.showModalN = true;
      }
    },
  },
};
</script>

<template>
  <Layout>
      <!-- Modal de Egreso-->
      <b-modal
          centered
          v-model="showModalN"
          title="Nueva egreso"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('save')">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Cantidad</label>
                  <input
                    id="name"
                    v-model="$v.formEgreso.cantidad.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese un cantidad"
                    :class="{
                      'is-invalid': $v.formEgreso.cantidad.$error,
                    }"
                    @input="$v.formEgreso.cantidad.$touch()"
                  />
                  <div
                    v-if="
                      $v.formEgreso.cantidad.$error &&
                      !$v.formEgreso.cantidad.required
                    "
                    class="invalid-feedback"
                  >
                    El cantidad es obligatorio.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Descripción</label>
                  <input
                    id="phone"
                    v-model="formEgreso.descripcion"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese una Descripción"
                    :class="{
                      'is-invalid':
                        submitted && $v.formEgreso.descripcion.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.formEgreso.descripcion.required"
                    class="invalid-feedback"
                  >
                    La descripción es requerida.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>
    <!-- Modal validacion caja -->
    <b-modal
      centered
      id="modalValidacion"
      title-class="text-black font-18"
      body-class="p-3"
      hide-header
      hide-footer
    >
      <h2>No se ha iniciado la caja</h2>
      <br />
      <div class="d-grid gap-2">
        <b-button variant="primary" @click="inicioRapido()"
          ><strong>REALIZAR INICIO DE CAJA RÁPIDO</strong></b-button
        >
      </div>
      <template #modal-footer="{}"> </template>
    </b-modal>

    <!-- Mostrar info caja -->
    <b-modal centered id="modalInfo" size="lg">
      <template #modal-header="{}">
        <!-- <h3>
          Registros del día {{ showDate(cajaActual.fecha_cierre) }}, recibe
          {{
            cajaActual.recibe.empleado.persona.nombre_persona +
            " " +
            cajaActual.recibe.empleado.persona.apellido_persona
          }}
        </h3> -->
      </template>
      <div no-body v-if="cajaActual">
        <h4>Inicio de caja</h4>
        <b-card style="background-color: #1e3052" class="text-white">
          <b-row>
            <b-col>
              <td>{{ cajaActual.observacion }}</td>
            </b-col>
            <b-col align="right">
              <td>{{ money(cajaActual.inicio_caja) }}</td>
            </b-col>
          </b-row>
        </b-card>
        <b-card no-body>
          <h4>Cierre de caja</h4>
          <table class="table">
            <thead
              align="center"
              style="background-color: #1e3052"
              class="text-white"
            >
              <tr>
                <th>EFECTIVO</th>
                <!-- <th>TRANSFERENCIA</th> -->
                <!-- <th>TARJETA</th> -->
                <th>DEPOSITO</th>
                <th><strong>TOTAL</strong></th>
              </tr>
            </thead>
            <tbody align="center">
              <tr>
                <td>{{ money(cajaActual.fin_caja) }}</td>
                <!-- <td>{{ money(cajaActual.fin_caja_transferencias) }}</td> -->
                <!-- <td>{{ money(cajaActual.fin_caja_tarjeta) }}</td> -->
                <td>{{ money(cajaActual.monto_deposito) }}</td>
                <td>{{ money(cajaActual.fin_sistema) }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-row>
          <b-col>
            <b-card style="background-color: #1e3052" class="text-white">
              <h4 class="text-white">Abonos</h4>
              <b-row>
                <b-col> TOTAL </b-col>
                <b-col align="right">
                  {{
                    money(
                      cajaActual.fin_abonos > 0 ? cajaActual.fin_abonos : 0.0
                    )
                  }}
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col>
            <b-card style="background-color: #1e3052" class="text-white">
              <h4 class="text-white">Egresos</h4>
              <b-row>
                <b-col> TOTAL </b-col>
                <b-col align="right">
                  {{
                    money(
                      cajaActual.fin_egresos > 0 ? cajaActual.fin_egresos : 0.0
                    )
                  }}
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <hr />
        <b-card no-body>
          <h4>Cierre del sistema</h4>
          <table class="table">
            <thead
              align="center"
              style="background-color: #154020"
              class="text-white"
            >
              <tr>
                <th>EFECTIVO</th>
                <th>TRANSFERENCIA</th>
                <th>TARJETA</th>
                <th>DEPOSITO</th>
                <th>CHEQUE</th>
                <th><strong>TOTAL</strong></th>
              </tr>
            </thead>
            <tbody align="center">
              <tr>
                <td>
                  {{
                    money(
                      cajaActual.fin_sistema_efectivo > 0
                        ? cajaActual.fin_sistema_efectivo
                        : 0.0
                    )
                  }}
                </td>
                <td>
                  {{
                    money(
                      cajaActual.fin_sistema_transferencia > 0
                        ? cajaActual.fin_sistema_transferencia
                        : 0.0
                    )
                  }}
                </td>
                <td>
                  {{
                    money(
                      cajaActual.fin_sistema_tarjeta > 0
                        ? cajaActual.fin_sistema_tarjeta
                        : 0.0
                    )
                  }}
                </td>
                <td>
                  {{
                    money(
                      cajaActual.fin_sistema_deposito > 0
                        ? cajaActual.fin_sistema_deposito
                        : 0.0
                    )
                  }}
                </td>
                <td>
                  {{
                    money(
                      cajaActual.fin_sistema_cheque > 0
                        ? cajaActual.fin_sistema_cheque
                        : 0.0
                    )
                  }}
                </td>
                <td>
                  {{
                    money(
                      cajaActual.fin_sistema > 0 ? cajaActual.fin_sistema : 0.0
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </div>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalInfo')">
          Cerrar
        </b-button>
      </template>
    </b-modal>
    <!-- Modal loading -->
    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-12">
                  <div class="text-center">
                    <div>
                      <h2>REGISTROS DE CAJA</h2>
                      <b-button v-if="estado_caja"
                            @click="onActionClicked('new-item')"
                              block
                              size="lg"
                              :variant=" 'warning'"
                            >
                              {{ "Registrar Egreso"
                              }}&nbsp;&nbsp;<i class="bx bxs-save"></i>
                            </b-button>
                    </div>
                    <hr />

                    <div class="row">
                      <div class="col" align="left">
                        <b-card>
                          <div class="row">
                            <div class="col">
                              <h4>
                                <i class="bx bx-caret-right"></i> INICIO DE CAJA
                              </h4>
                            </div>
                            <div class="col" align="right" v-show="!validarEdit && estado_caja == true">
                              <switches
                                :disabled="!validateCaja"
                                @input="toEditInicio"
                                color="primary"
                                v-model="swInicio"
                                text-disabled="Sin edición"
                                text-enabled="Editando"
                              >
                              </switches>
                            </div>
                          </div>
                          <br />
                          <label>CANTIDAD EN CAJA</label>
                          <masked-input
                            v-if="swInicio"
                            :disabled="disabledInicio"
                            v-model.trim="$v.temp_inicio.$model"
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            placeholder="Ingrese la cantidad"
                            :class="{
                              'is-invalid': $v.temp_inicio.$error,
                            }"
                            class="form-control"
                          />
                          <masked-input
                            v-else
                            :disabled="disabledInicio"
                            v-model.trim="$v.formInicio.inicio.$model"
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            placeholder="Ingrese la cantidad"
                            :class="{
                              'is-invalid': $v.formInicio.inicio.$error,
                            }"
                            class="form-control"
                          />
                          <br />
                          <label>OBSERVACIÓN</label>
                          <b-input
                            v-if="!swInicio"
                            :disabled="disabledInicio"
                            v-model="formInicio.observacion_inicio"
                            placeholder="Ingrese la observación"
                          ></b-input>
                          <b-input
                            v-else
                            :disabled="swInicio"
                            v-model="tempObservacion_inicio"
                          ></b-input>
                          <br />
                          <div class="d-grid gap-2">
                            <b-button
                              :disabled="disabledInicio"
                              @click="
                                !swInicio ? validateInicio() : editInicio()
                              "
                              block
                              size="lg"
                              :variant="!swInicio ? 'primary' : 'warning'"
                            >
                              {{
                                !swInicio
                                  ? "REGISTRAR INICIO"
                                  : "EDITAR REGISTRO"
                              }}&nbsp;&nbsp;<i class="bx bxs-save"></i>
                            </b-button>
                          </div>
                        </b-card>
                        <b-card v-if="arrayCajas.length > 0">
                          <h4>REGISTROS DEL DÍA</h4>
                          <table class="table">
                            <thead>
                              <tr>
                                <th>ACCIONES</th>
                                <th>INICIO</th>
                                <!-- <th>OBSERVACION</th> -->
                                <th>CIERRE</th>
                                <th>FECHA - HORA</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, idx) in arrayCajas"
                                v-bind:key="idx"
                              >
                                <td align="center">
                                  <router-link
                                      :to="{
                                      name: 'vistaComprobanteCaja',
                                      params: { id: item.id },
                                    }"
                                  >
                                  <b-button
                                    size="sm"
                                    variant="outline-info"
                                    @click="infoCaja(idx)"
                                    ><i :class="'bx bx-show'" />&nbsp;&nbsp;Ver
                                    más</b-button
                                  >
                                  </router-link>
                                </td>
                                <td>{{ money(item.inicio_caja) }}</td>
                                <!-- <td>{{ item.observacion }}</td> -->
                                <td>{{ money(item.fin_caja) }}</td>
                                <td>{{ showHour(item.fecha_hora_cierre) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </b-card>
                      </div>
                      <div class="col" align="left"   v-show="estado_caja">
                        <b-card>
                          <div class="row">
                            <div class="col">
                              <h4>
                                <i class="bx bx-caret-left"></i> CIERRE DE CAJA
                              </h4>
                            </div>
                          </div>
                        
                          <label>CANTIDAD EN EFECTIVO</label>
                          <masked-input
                          
                            :disabled="disabledCierre"
                            v-model.trim="$v.formCierre.cierre_efectivo.$model"
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            placeholder="Ingrese la cantidad en efectivo"
                            :class="{
                              'is-invalid':
                                $v.formCierre.cierre_efectivo.$error,
                            }"
                            class="form-control"
                          />
                          <br />
                          <!-- <label>CANTIDAD EN TRANSFERENCIAS</label>
                          <masked-input
                            :disabled="disabledCierre"
                            v-model.trim="
                              $v.formCierre.cierre_transferencia.$model
                            "
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            placeholder="Ingrese la cantidad en transferencias"
                            :class="{
                              'is-invalid':
                                $v.formCierre.cierre_transferencia.$error,
                            }"
                            class="form-control"
                          />
                          <br />
                          <label>CANTIDAD EN TARJETA</label>
                          <masked-input
                            :disabled="disabledCierre"
                            v-model.trim="$v.formCierre.cierre_tarjeta.$model"
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            placeholder="Ingrese la cantidad en tarjeta"
                            :class="{
                              'is-invalid': $v.formCierre.cierre_tarjeta.$error,
                            }"
                            class="form-control"
                          /> -->
                          <br />
                          <label>CANTIDAD EN DEPOSITO</label>
                          <masked-input
                            :disabled="disabledCierre"
                            v-model.trim="$v.formCierre.cierre_deposito.$model"
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            placeholder="Ingrese la cantidad en depositos"
                            :class="{
                              'is-invalid':
                                $v.formCierre.cierre_deposito.$error,
                            }"
                            class="form-control"
                          />
                          <br />
                          <div class="d-grid gap-2">
                            <b-button
                              :disabled="disabledCierre"
                              @click="validateCierre()"
                              block
                              size="lg"
                              variant="primary"
                            >
                              REGISTRAR CIERRE&nbsp;&nbsp;<i
                                class="bx bxs-save"
                              ></i>
                            </b-button>
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
